
import { Route, Routes } from 'react-router-dom';
import './App.css'
import { authRoute, parentRouteCollection, routeCollection, staffRouteCollection } from './routes/routes';
import NotFound from './routes/NotFound';
import MainLayouts from './layout/main/MainLayouts';
import StarffLayout from './layout/main/StarffLayout';
import ParentLayout from './layout/main/ParentLayout';
import ProtectedRoute from './routes/ProtectedRoute';
import RootRedirect from './routes/RootRedirect';
import LockRedirect from './routes/LockRedirect';
import Unauthorized from './routes/Unauthorized';
import ScrollToTop from './utils/ScrollToTop';
import { useSocket } from './utils/socket/useSocket';


function App() {

  useSocket()
  
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<LockRedirect />} >
          <Route path="/" element={<RootRedirect />} />
          {authRoute.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
          <Route element={<ProtectedRoute allowedRole="Admin" />}>
            <Route element={<MainLayouts />}>
              {routeCollection.map((route, index) =>
                route.children ? (
                  <Route key={index} path={route.path} element={route.element}>
                    {route.children.map((child, i) => (
                      <Route key={i} path={child.path} element={child.element} />
                    ))}
                  </Route>
                ) : (
                  <Route key={index} path={route.path} element={route.element} />
                )
              )}
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedRole="Staffs" />}>
            <Route element={<StarffLayout />}>
              {staffRouteCollection.map((route, index) =>
                route.children ? (
                  <Route key={index} path={route.path} element={route.element}>
                    {route.children.map((child, i) => (
                      <Route
                        key={i}
                        path={child.path}
                        element={
                          <ProtectedRoute
                            module={child.module}
                            action={child.action}
                          >
                            {child.element}
                          </ProtectedRoute>
                        }
                      />
                    ))}
                  </Route>
                ) : (
                  <Route
                    key={index}
                    path={route.path}
                    element={
                      <ProtectedRoute module={route.module} action={route.action}>
                        {route.element}
                      </ProtectedRoute>
                    }
                  />
                )
              )}
            </Route>
          </Route>
          <Route element={<ProtectedRoute allowedRole="Parents" />}>
            <Route element={<ParentLayout />}>
              {parentRouteCollection.map((route, index) =>
                route.children ? (
                  <Route key={index} path={route.path} element={route.element}>
                    {route.children.map((child, i) => (
                      <Route key={i} path={child.path} element={child.element} />
                    ))}
                  </Route>
                ) : (
                  <Route key={index} path={route.path} element={route.element} />
                )
              )}
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
